import React from 'react';
import {Card, Header, Button, Select, Form, Radio} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import isEmpty from 'lodash/isEmpty';
import Placeholder from '../../../common/components/placeholder';
import './tcc.scss';
import Search from './Search';
import Subheader from './Subheader';
import includes from 'lodash/includes';
import GalleryVehicle from './GalleryVehicle';
import FilesUpload from './FilesUpload';
import ShowInformationVehicle from './ShowInformationVehicle';
import FormVehicle from './FormVehicle';
import FormVehicleWarranty from './FormVehicleWarranty';
import moment from 'moment';
import SectionCaption from './SectionCaption';
import {validateStatus, handleErrorCPO, handleErrorWarranty, processFiles, vehicleStatusContition} from '../../utils';
import ModalComfirm from './Modal';
import result from 'lodash/result';
import find from 'lodash/find';
import Loader from '../../../common/components/loader';


import {
  STATE_OPTIONS_CPOS,
  STATE_OPTIONS_WARRANTY,
  ERROR_MESSAGE_ACCESORIES,
  DATEFORMAT,
  MAXFILESIZEKB,
  FILE_NAMES,
} from '../../constants';
import HeaderLogo from '../../common/HeaderLogo';
import FilesUploadWarranty from './FilesUploadWarranty';


const INITIAL_STATE = {
  'search': '',
  'firstSearch': false,
  'accessory': '',
  'accessories': [],
  'description': '',
  'endSaleDate': null,
  'priceSale': '',
  'enrollment': 2019,
  'km': '',
  'digitPlaque': 0,
  'side': [],
  'frontal': [],
  'back': [],
  'inner': [],
  'board': [],
  'document': [],
  'others': [],
  'statusRequest': '',
  'observation': '',
  'vehCertId': '',
  'open': false,
  'changeImage': true,
  'blockDate': false,
  'showVehicle': false,
  'city': 'PICHINCHA',
  'vehicleStatus': '',
};

class VehicleCertification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      'typeForm': 'CPO',
    };

    if (window.performance) {
      if (performance.navigation.type !== 1) {
        this.props.clearVehicle();
        this.props.clearImages();
      }
    }
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.VehiclesCertification, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    const {id} = this.props.params;
    const state = this.props.location && this.props.location.state;

    const type = state && state !== 'undefined' ? state.typeForm : 'CPO';
    

    if (id) {
      this.setState({'open': true, 'typeForm': type});
      this.props.getVehicleByChasis(id, true, type);
    }
  }

  componentWillUnmount() {
    this.props.clearVehicle();
    this.props.clearImages();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle.chasis !== this.props.vehicle.chasis ||
        prevProps.vehicle.typeForm !== this.props.vehicle.typeForm
    ) {
      this.setState({
        'accessories':
          this.props.vehicle.detail && this.props.vehicle.detail.length > 0 ?
            this.props.vehicle.detail.map(({accessory}) => accessory) :
            [],
        'endSaleDate': this.props.vehicle.dealerSale ? moment(this.props.vehicle.dealerSale).toDate() : null,
        'blockDate': this.props.vehicle.dealerSale ? true : false,
        'description': this.props.vehicle.description ? this.props.vehicle.description : '',
        'priceSale': this.props.vehicle.salesPrice ? this.props.vehicle.salesPrice : '',
        'enrollment': this.props.vehicle.carIdYear ? this.props.vehicle.carIdYear : '',
        'km': this.props.vehicle.kilometer ? this.props.vehicle.kilometer : '',
        'digitPlaque': this.props.vehicle.digit,
        'status': this.props.vehicle.status ? this.props.vehicle.status : '',
        'city': this.props.vehicle.city,
        'statusRequest': this.props.vehicle.status ? this.props.vehicle.status : '',
        'observation': this.props.vehicle.aprobeArgument ? this.props.vehicle.aprobeArgument : '',
        'vehCertId': this.props.vehicle.vehCertId ? this.props.vehicle.vehCertId : '',
        'sectionReview2': this.props.vehicle.status === 'APROBADO' ? true : false,
        'sectionReview3': this.props.vehicle.status === 'APROBADO' ? true : false,
        'showVehicle': this.props.vehicle.showVehicle === 'MOSTRAR' ? true : false,
        'vehicleStatus': vehicleStatusContition(this.props),

      });
    }
  }

  handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    this.setState({
      [name]: value,
      'firstSearch': false,
      'open': false,
    });
  };

  handleChangeTypeForm = (e, name, value) => {
    this.setState({
      [name]: value,
      ...INITIAL_STATE,
    }, () => {
      this.props.clearVehicle();
      this.props.clearImages();
    });
  };

  handleSelect = (e, name, value) => {
    this.setState({
      [name]: value,
    });
  };

  handleSelectStatus = (e, name, value) => {
    const {endSaleDate} = this.state;
    this.setState({
      [name]: value,
      'endSaleDate': value === 'NUEVO' ? moment().toDate() : endSaleDate,
    });
  };

  handleSearchChasis = (e) => {
    const {search, typeForm} = this.state;
    this.props.clearImages();
    this.props.clearVehicle();
    this.props.getVehicleByChasis(search, true, typeForm);

    this.setState((previousState, currentProps) => {
      return {
        'open': !isEmpty(currentProps.vehicle) ? false : true,
        'search': '',
        'firstSearch': true,
        'side': [],
        'frontal': [],
        'back': [],
        'inner': [],
        'board': [],
        'document': [],
        'others': [],
        'changeImage': true,
        'sectionReview2': false,
        'sectionReview3': false,
      };
    });
  };

  handleAddAccessory = () => {
    const {accessory} = this.state;
    const accessories = [...this.state.accessories];
    const verifiedAccessory = includes(accessories, accessory.toUpperCase().trim());

    if (!verifiedAccessory) {
      accessories.push(accessory.toUpperCase().trim());
      this.setState({
        accessories,
        'accessory': '',
      });
    } else {
      this.props.addMessageBoxError(ERROR_MESSAGE_ACCESORIES);
    }
  };

  handleDeleteAccessory = (name) => {
    const accessories = [...this.state.accessories];
    this.setState({
      'accessories': accessories.filter((acc) => acc !== name),
    });
  };

  handleChangeDate = (date) => {
    this.setState({
      'endSaleDate': moment(date).toDate(),
    });
  };

  handleMilesInput = (event, name) => {
    this.setState({
      [name]: event.value,
    });
  };

  handleImages = (files, name) => {
    const filterFiles = files.filter((fileItem) => fileItem.file.size <= MAXFILESIZEKB);
    this.setState({
      [name]: filterFiles.map((fileItem) => fileItem.file),
    }, () => {
      this.setState({
        'changeImage': false,
      });
    });
  };

  handleSave = (action) => {
    const {sectionReview2, sectionReview3} = this.state;
    if (action === 'APROBADO') {
      if (sectionReview2 && sectionReview3) {
        this.wrapperSaveCertificate(action);
      } else {
        this.props.addMessageBoxError('Marque las casillas de cada sección para indicar que esta completa la revisión');
      }
    } else {
      this.wrapperSaveCertificate(action);
    }
  };

  // eslint-disable-line max-statements
  // eslint-disable-next-line max-statements
  wrapperSaveCertificate = (status = 'INGRESADO') => {
    const {
      side,
      frontal,
      back,
      inner,
      board,
      document,
      others,
      accessories,
      description,
      endSaleDate,
      priceSale,
      enrollment,
      km,
      city,
      digitPlaque,
      observation,
      showVehicle,
      typeForm,
      statusRequest,
      vehicleStatus,
    } = this.state;
    const files = [...side, ...frontal, ...back, ...inner, ...board, ...document, ...others];
    const formData = processFiles(files);
    const {vehCertId} = this.props.vehicle;
    const {user, scopePermission} = this.props;

    const data = {
      ...this.props.vehicle,
      'detail': accessories.map((accessory) => {
        return {accessory};
      }),
      'city': city,
      'description': description,
      'dealerSale': vehicleStatus === 'NUEVO' ? moment().format(DATEFORMAT) : moment(endSaleDate).format(DATEFORMAT),
      'salesPrice': priceSale,
      'carIdYear': enrollment,
      'kilometer': km,
      'carIdDigit': digitPlaque,
      'infSection': 0,
      'imgSection': 0,
      'action': vehCertId ? 'update' : 'insert',
      'aprobeUser': scopePermission ? user.toUpperCase() : null,
      'aprobeArgument': scopePermission ? observation : null,
      'showVehicle': showVehicle ? 'MOSTRAR' : 'NO-MOSTRAR',
      'vehCertUser': this.props.vehicle.vehCertUser ? this.props.vehicle.vehCertUser : '',
      typeForm,
      'status': statusRequest === 'APROBADO' ? 'APROBADO' : status,
      vehicleStatus,
    };

    const {error, errorMessage} = handleErrorCPO(this.state);
    const {errorWarranty, errorMessageWarranty} = handleErrorWarranty(this.state);

    if (error && typeForm === 'CPO') {
      this.props.addMessageBoxError(errorMessage);
    } else if (errorWarranty && typeForm === 'Garantía') {
      this.props.addMessageBoxError(errorMessageWarranty);
    } else {
      this.props.addSaveRequestCertification(data, this.props.vehicle.chasis, formData, typeForm);
    }
  };

  handleModal = () => {
    this.setState({
      'open': false,
    });
  };

  render() {
    const {
      search,
      firstSearch,
      side,
      frontal,
      back,
      inner,
      board,
      document,
      others,
      changeImage,
      statusRequest,
      observation,
      sectionReview2,
      sectionReview3,
      blockDate,
      showVehicle,
      typeForm,
    } = this.state;
    const {chasis, vehCertId, status} = this.props.vehicle;
    const {scopePermission, images, loadingImages, loading} = this.props;
    const validateStatusResp = validateStatus(status, scopePermission);
    const imageObj = {};
    const othersArr = [];
    images.forEach((image) => {
      const name = image.name;
      const sliceNameExt = name.slice(0, name.indexOf('.'));
      // slice(0, 6) the limit of names to exclude others
      if (FILE_NAMES.slice(0, 6).indexOf(sliceNameExt) >= 0) {
        imageObj[sliceNameExt] = image;
      } else {
        othersArr.push(image);
        imageObj.others = othersArr;
      }
    });
    const validateTypeForm = typeForm === 'CPO' ? true : false;
    
    if (loadingImages || loading) {
      return <Loader/>;
    }

    return (
      <div>
        <Card raised fluid>
          <div className="tcc-header">
            <div className="tcc-container-header">
              <HeaderLogo title={'Toyota certificados'}/>
              <div className="tcc-container-header-radios">
                <Form>
                  <label>Tipo de Registro</label>
                  <Form.Group >
                    <Form.Field
                      disabled={loading}
                      control={Radio}
                      label="CPO"
                      value='CPO'
                      checked={typeForm === 'CPO'}
                      onChange={(e, {value}) => this.handleChangeTypeForm(e, 'typeForm', value)}
                    />
                    <Form.Field
                      disabled={loading}
                      control={Radio}
                      label='Garantía'
                      value='Garantía'
                      checked={typeForm === 'Garantía'}
                      onChange={(e, {value}) => this.handleChangeTypeForm(e, 'typeForm', value)}
                    />
                  </Form.Group >
                </Form>
              </div>
            </div>
            <div className="tcc-header-search-container">
              <Search search={search} handleSearchChasis={this.handleSearchChasis} handleInput={this.handleInput} />
              {!isEmpty(this.props.vehicle) && (
                <div className="tcc-btns" style={{'width': `${scopePermission ? '350px' : '300px'} `}}>
                  {this.state.open && (
                    <ModalComfirm
                      validateTypeForm={validateTypeForm}
                      vehicle={this.props.vehicle}
                      open={this.state.open}
                      handleModal={this.handleModal}
                    />
                  )}
                  {scopePermission ? (
                    <React.Fragment>
                      <Select
                        value={statusRequest}
                        placeholder="Seleccione el estado"
                        options={validateTypeForm ? STATE_OPTIONS_CPOS : STATE_OPTIONS_WARRANTY }
                        onChange={(e, {value}) => this.handleSelect(e, 'statusRequest', value)}
                      />
                      <Button className="btn-tcc"
                        disabled={loading} color="green" onClick={() => this.handleSave(statusRequest)}>
                        GUARDAR
                      </Button>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <Button className="btn-tcc"
                        disabled={loading || status === 'VENDIDO' || status === 'ENVIADO' || status === 'APROBADO'}
                        color="black"
                        onClick={() => this.handleSave('ENVIADO')}>
                        ENVIAR
                      </Button>
                      <Button className="btn-tcc" disabled={validateStatusResp || loading || status === 'VENDIDO'}
                        color="green" onClick={() => this.handleSave('INGRESADO')}>
                        {vehCertId ? 'ACTUALIZAR' : 'GUARDAR'}
                      </Button>
                    </React.Fragment>
                  )}
                </div>
              )}
            </div>
          </div>
        </Card>
        {isEmpty(this.props.vehicle) ? (
          <Placeholder
            text={!firstSearch ? 'Por favor ingrese un chasis' : 'No se encontró un vehículo con ese chasis '}
            src={`${process.env.PUBLIC_URL}/icons/CarPlaceholder.svg`}
            alt="carro"
          ></Placeholder>
        ) : (
          <Card raised fluid>
            <div className="tcc-information">
              <Header as="h2">
                Información
                <SectionCaption text={'sección 1'} />
                <span className="tcc-caption">Chasis: {chasis}</span>
              </Header>
              {vehCertId && (
                <p className="tcc-label">
                  No. <span className="tcc-label__number">{vehCertId}</span>
                </p>
              )}
            </div>
            <ShowInformationVehicle vehicle={this.props.vehicle}></ShowInformationVehicle>
            <Subheader
              title={'Complete la siguiente información'}
              subtitle={'Esta información es requerida para completar el registro del vehículo'}
              text={'sección 2'}
              sectionReview={sectionReview2}
              sectionReviewName={'sectionReview2'}
              handleSelect={this.handleSelect}
              scopePermission={scopePermission}
            />
          
            {
              validateTypeForm ?
                <FormVehicle
                  vehicleState={this.state}
                  handleInput={this.handleInput}
                  handleAddAccessory={this.handleAddAccessory}
                  handleDeleteAccessory={this.handleDeleteAccessory}
                  handleChangeDate={this.handleChangeDate}
                  handleSelect={this.handleSelect}
                  handleMilesInput={this.handleMilesInput}
                  validateStatus={validateStatusResp}
                  blockDate={blockDate}
                /> : <FormVehicleWarranty
                  vehicleState={this.state}
                  blockDate={blockDate}
                  validateStatus={validateStatusResp}
                  handleSelect={this.handleSelect}
                  handleSelectStatus={this.handleSelectStatus}
                  handleChangeDate={this.handleChangeDate}
                  handleMilesInput={this.handleMilesInput}
                />
            }
    
            <Subheader
              showCheck={validateTypeForm}
              title={'Carga de archivos'}
              sectionReview={sectionReview3}
              sectionReviewName={'sectionReview3'}
              handleSelect={this.handleSelect}
              showVehicleName={'showVehicle'}
              showVehicle={showVehicle}
              subtitle={ validateTypeForm ? `Es necesario la carga del documento de
              inspección y mínimo 5 fotos del vehículo que se  muestra a continuación.` :
                'Es necesaría la carga del formulario si el vehículo tiene mas de 5000 km'
              }
              text={'sección 3'}
              scopePermission={scopePermission}
            />


            <div className="tcc-wrapper">
              {
                validateTypeForm ?
                  <React.Fragment>
                    <GalleryVehicle />
                    <FilesUpload
                      validateStatus={validateStatusResp}
                      side={ changeImage && imageObj[FILE_NAMES[0]] ? [imageObj[FILE_NAMES[0]]] : side}
                      frontal={changeImage && imageObj[FILE_NAMES[1]] ? [imageObj[FILE_NAMES[1]]] : frontal}
                      back={changeImage && imageObj[FILE_NAMES[2]] ? [imageObj[FILE_NAMES[2]]] : back}
                      inner={changeImage && imageObj[FILE_NAMES[3]] ? [imageObj[FILE_NAMES[3]]] : inner}
                      board={changeImage && imageObj[FILE_NAMES[4]] ? [imageObj[FILE_NAMES[4]]] : board}
                      document={changeImage && imageObj[FILE_NAMES[5]] ? [imageObj[FILE_NAMES[5]]] : document}
                      pdfLink={imageObj[FILE_NAMES[5]] && URL.createObjectURL(imageObj[FILE_NAMES[5]])}
                      others={changeImage && imageObj[FILE_NAMES[6]] ? imageObj[FILE_NAMES[6]] : others}
                      handleImages={this.handleImages}
                    />
                  </React.Fragment> :
                  <FilesUploadWarranty
                    document={changeImage && imageObj[FILE_NAMES[5]] ? [imageObj[FILE_NAMES[5]]] : document}
                    pdfLink={imageObj[FILE_NAMES[5]] && URL.createObjectURL(imageObj[FILE_NAMES[5]])}
                    handleImages={this.handleImages}
                  />
              }
            </div>
            {scopePermission && validateTypeForm && (
              <div className="tcc-wrapper">
                <Form>
                  <Form.TextArea
                    name="observation"
                    value={observation}
                    onChange={this.handleInput}
                    label="Observación"
                    placeholder="Describir observación..."
                  />
                </Form>
              </div>
            )}
          </Card>
        )}
      </div>
    );
  }
}

const {
  getVehicleByChasis,
  addMessageBoxError,
  clearVehicle,
  addSaveRequestCertification,
  clearImages,
  withRouter,
} = Actions;

const mapStateToProps = (state, ownProps) => {
  const searchTcc = result(
    find(state.session.permissions, (permission) => permission.rsname === 'CPO'),
    'scopes'
  ) || [];
  const vehicle = state.vehicleCertification.vehicle;
  const loading = state.vehicleCertification.loading;
  return {
    'permissions': state.session.permissions,
    'user': state.session.user,
    'push': ownProps.history.push,
    loading,
    vehicle,
    'location': ownProps.history.location,
    'images': state.vehicleCertificationImages.images,
    'loadingImages': state.vehicleCertificationImages.loading,
    'scopePermission': searchTcc.indexOf('Certificados') >= 0,
  };
};

export default withRouter(connect(
  mapStateToProps,
  {
    getVehicleByChasis,
    addMessageBoxError,
    clearVehicle,
    addSaveRequestCertification,
    clearImages,
  }
)(VehicleCertification));
